import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import HeaderBottom from '../../components/HomePage/HeaderBottom';

const VideoSection = () => {

    const [video, setVideo] = useState([]);
    const [items, setItems] = useState([]);



    const [page, setPage] = useState([]);
    const [selectedSlug, setSelectedSlug] = useState(""); // State to store pageSlug

    useEffect(() => {
        fetch(`https://aprilone-178ea8362c0b.herokuapp.com/page`)
            .then((res) => res.json())
            .then((info) => setPage(info));
    }, []);

    const handlePageChange = (e) => {
        const selectedPage = page.find((p) => p.pageName === e.target.value);
        setSelectedSlug(selectedPage ? selectedPage.pageSlug : ""); // Store selectedSlug
    };

    useEffect(() => {
        fetch(`https://aprilone-178ea8362c0b.herokuapp.com/videos`)
            .then((res) => res.json())
            .then((info) => setVideo(info));
    }, []);

    useEffect(() => {
        fetch(`https://aprilone-178ea8362c0b.herokuapp.com/videos-items`)
            .then((res) => res.json())
            .then((info) => setItems(info));
    }, []);

    const handleVideoSection = (event) => {
        event.preventDefault();
        const pageName = event.target.pageName.value;
        const headingVideo = event.target.headingVideo.value;
        const subheadingVideo = event.target.subheadingVideo.value;
        const TextVideo = event.target.TextVideo.value;
        const videoImage = event.target.videoImage.value;
        const videoLink = event.target.videoLink.value;

        const videoSection = {
            pageName,
            headingVideo,
            subheadingVideo,
            TextVideo,
            pageSlug: selectedSlug,
            videoImage,
            videoLink,
        };

        const url = `https://aprilone-178ea8362c0b.herokuapp.com/add-video`;
        fetch(url, {
            method: "POST",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(videoSection),
        })
            .then((res) => res.json())
            .then((result) => {
                alert(' Video Section is Updated');
            });
    };

    return (
        <>
            <HeaderBottom />
            <div>
                <section id="services" className="services-area vh-100">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8 col-md-12 text-center">
                                <h2 className="mb-5 mt-5">Update Video Section</h2>

                                <table className="table table-bordered">
                                    <thead className="bg-primary text-white">
                                        <tr>
                                            <th>Sl No</th>
                                            <th>Page Name</th>
                                            <th>Heading Testimonial</th>
                                            <th>Edit/Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {video.map((page, index) => (
                                            <tr key={page._id}>
                                                <td>{index + 1}</td>
                                                <td>{page.pageName}</td>
                                                <td>{page.headingVideo}</td>
                                                <td>
                                                    <Link to={`/videotext-edit/${page._id}`} className="btn  btn-warning">
                                                        <i className="fas fa-edit"></i>  Edit Now
                                                    </Link>
                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </table>


                                <form className="contact-form" onSubmit={handleVideoSection}>

                                    <div className="text-black">
                                        <select
                                            name="pageName"
                                            className="form-select w-100 px-3 py-2 mb-3 border border-gray-300 rounded-lg "
                                            required
                                            style={{ color: 'black' }}
                                            onChange={handlePageChange}
                                        >
                                            <option value="" disabled selected>
                                                Select Page
                                            </option>
                                            {page.map((p) => (
                                                <option key={p._id} value={p.pageName}>
                                                    {p.pageName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Display the selected pageSlug in an input */}
                                    <div className="col-lg-12 col-md-12 ">
                                        <div className="form-group">
                                            <input hidden
                                                type="text"
                                                className="form-control "
                                                value={selectedSlug} // Set value from state
                                                readOnly
                                                placeholder="Page Slug"
                                            />
                                        </div>
                                    </div>


                                    <div className="row justify-content-center">
                                        <div className="col-lg-12 mb-3">
                                            <div className="contact-field p-relative c-name mb-20 ">
                                                <input type="text" className="form-control " name="headingVideo" placeholder="Video Section Heading" required />
                                            </div>
                                        </div>
                                        <div className="col-lg-12 mb-3">
                                            <div className="contact-field p-relative c-name mb-20 ">
                                                <input type="text" className="form-control " name="subheadingVideo" placeholder="Video Sub Heading" required />
                                            </div>
                                        </div>
                                        <div className="col-lg-12 mb-3">
                                            <div className="contact-field p-relative c-name mb-20">
                                                <input type="text" className="form-control " name="TextVideo" placeholder="Video Section Text" required />
                                            </div>
                                        </div>
                                        <div className="col-lg-12 mb-3">
                                            <div className="contact-field p-relative c-name mb-20">
                                                <input type="text" className="form-control " name="videoImage" placeholder="Video Image URL" required />
                                            </div>
                                        </div>
                                        <div className="col-lg-12 mb-3">
                                            <div className="contact-field p-relative c-name mb-20">
                                                <input type="text" className="form-control " name="videoLink" placeholder="Video Link URL" required />
                                            </div>
                                        </div>
                                        <div className="slider-btn">
                                            <button className="button-professional" data-animation="fadeInRight" data-delay=".8s">
                                                Update Video Section
                                            </button>
                                        </div>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default VideoSection;
